import { InjectionToken } from "@angular/core";


export const HTTP_SERVICE_URL = new InjectionToken<string>('http-service-url');
